import api from "../../services/api";

const usePlans = () => {
  const findAll = async (params) => {
    const { data } = await api.request({
      url: `/helps`,
      method: "GET",
      params,
    });
    return data;
  };

  const list = async (params) => {
    const { data } = await api.request({
      url: "/helps/list",
      method: "GET",
      params,
    });
    return data;
  };

  const save = async (data) => {
    const { data: responseData } = await api.request({
      url: "/helps",
      method: "POST",
      data,
    });
    try {
      document.dispatchEvent(
        new CustomEvent("helps:changed", {
          detail: { action: "save", data: responseData },
        })
      );
    } catch (e) {
      /* no-op */
    }
    return responseData;
  };

  const update = async (data) => {
    const { data: responseData } = await api.request({
      url: `/helps/${data.id}`,
      method: "PUT",
      data,
    });
    try {
      document.dispatchEvent(
        new CustomEvent("helps:changed", {
          detail: { action: "update", data: responseData },
        })
      );
    } catch (e) {
      /* no-op */
    }
    return responseData;
  };

  const remove = async (id) => {
    const { data } = await api.request({
      url: `/helps/${id}`,
      method: "DELETE",
    });
    try {
      document.dispatchEvent(
        new CustomEvent("helps:changed", { detail: { action: "remove", id } })
      );
    } catch (e) {
      /* no-op */
    }
    return data;
  };

  return {
    findAll,
    list,
    save,
    update,
    remove,
  };
};

export default usePlans;
